export default function delExtraSpaces(str: string): string {
  return (str || '').trim().replace(/\s+/g, ' ');
}
